export const homeData = {
  hero: {
    title: "苍井空",
    subtitle: "从成人偶像到艺术家的真实人生",
    description: "她曾是日本最具话题性的人物之一，如今却以艺术家、妻子、母亲的身份重新定义自我。这是一个关于勇气、蜕变与重生的真实故事。",
    ctaText: "探索她的故事",
    ctaLink: "/category/rensheng-guiji"
  },
  timeline: [
    {
      year: "1983",
      title: "诞生",
      description: "11月11日出生于日本东京都一个普通家庭。"
    },
    {
      year: "2002",
      title: "出道",
      description: "19岁正式出道，迅速成为日本最具人气的艺人之一。"
    },
    {
      year: "2010",
      title: "进军中国",
      description: "开通微博账号，首日粉丝突破20万，开启在华影响力。"
    },
    {
      year: "2011",
      title: "引退转型",
      description: "正式宣布从成人影视行业引退，开启艺术创作之路。"
    },
    {
      year: "2018",
      title: "步入婚姻",
      description: "元旦宣布与DJ NON结婚，开启人生新篇章。"
    },
    {
      year: "2019",
      title: "成为母亲",
      description: "5月顺利产下双胞胎儿子，完成从妻子到母亲的角色转变。"
    },
    {
      year: "2024",
      title: "艺术绽放",
      description: "在东京举办大型个人画展《绽放》，持续活跃于艺术与公益领域。"
    }
  ]
};